import type { FeedbackAnswerQuestion, QuestionData, QuestionSerialized } from '@repo/types/questions/Question';
import type { IQuestion } from '@repo/types/questions/Question.interface';

import { QuestionFactory } from '@repo/lib/quiz/questions/class/QuestionFactory';
import { useMemo } from 'react';

import type { CorrectType } from '@/components/ui/quiz';

import { CorrectIcon } from '@/components/ui/quiz';
import { ElementLink } from '@/components/ui/scroll';

interface QuizQuestionResultCardProps {
  question: QuestionData;
  marked: FeedbackAnswerQuestion;
  answer: QuestionSerialized['selectedAnswer'] | null;
  idx: number;
  sectionIdx: number;
}

export default function QuizQuestionResultCard(quizQuestionResultCardProps: QuizQuestionResultCardProps) {
  const { question, answer, marked, idx, sectionIdx } = quizQuestionResultCardProps;

  const correctState = useMemo<CorrectType>(() => {
    const qFactory = new QuestionFactory();
    const qClass: IQuestion = qFactory.createQuestion(question, null, marked);
    if (answer) qClass.importAnswer(answer);
    return qClass.correctState();
  }, [question, answer, marked]);

  return (
    <ElementLink to={`section-${sectionIdx}/question-${idx}`} activeClass="ring-2 ring-focus-ring" asChild>
      <div className="bg-card relative flex h-9 w-16 items-center justify-center rounded-sm shadow-sm">
        <div className="absolute top-0 right-0">
          <CorrectIcon answerState={correctState} />
        </div>
        <div>{`${sectionIdx + 1}.${idx + 1}`}</div>
      </div>
    </ElementLink>
  );
}
